module.exports = __webpack_public_path__ + "img/Togo.f5050d88.gif";